/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';

import { PeriodRenderer } from './period.renderer';
import {ICellRendererParams} from "ag-grid-community";

/**
 *
 * @class DurationRenderer
 *
 * @brief variation of period rendering, limited to 24 hours.
 *
 * - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class DurationRenderer extends PeriodRenderer {

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    /* configure for 24 hours only */

    this.noDays = true;

    super.init(params);

  }
}
